export default __webpack_public_path__ + "f4052f428a0820f3a4aa0ebdd9890d3b.xlsx";